import React from "react";
import { moreTestimonials } from "../../data/megapack";
import { E } from "../Emoji";
import { TestimonialCard } from "../TestimonialCard";
export function MoreTestimonials() {
  return <section aria-labelledby="opiniones" className="bg-night" data-id="element-204" data-mp="2bnndxhgic031">
      <div className="mx-auto max-w-2xl px-5 py-14" data-id="element-205" data-mp="2bq9ir9c0k1hk">
        <h2 id="opiniones" className="text-center text-3xl font-black leading-tight text-white" data-id="element-206" data-mp="26o2246g8nx8w">
          <E data-id="element-207" data-mp="22nqmx96nap4t">❤️ MÁS PERSONAS QUE YA LO TIENEN</E>
        </h2>
        <div className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-208" data-mp="1xws1jv6sv0up">
          {moreTestimonials.map(t => <TestimonialCard key={t.name} testimonial={t} variant="detailed" data-id="element-209" data-mp="1sxouy6b68mkm" />)}
        </div>
      </div>
    </section>;
}